export default function HeroSection() {
  return (
    <section className="w-full bg-background-50 relative overflow-hidden">
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-grid-pattern pointer-events-none"></div>

      {/* Subtle radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] rounded-full bg-primary-500/5 blur-[120px] pointer-events-none"></div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-36 lg:py-48">
        <div className="max-w-4xl mx-auto text-center">
          {/* Engineering descriptor — small pill above headline */}
          <div className="fade-up mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-foreground-50/5 rounded-full text-xs font-label text-foreground-300 tracking-widest uppercase">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              Engineering team
            </span>
          </div>

          {/* Main headline */}
          <h2 className="fade-up fade-up-delay-1 font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-50 leading-[1.05] tracking-tight">
            Engineering<br />
            <span className="text-primary-500">precision</span> for<br />
            the <span className="text-primary-500">iOS</span> platform
          </h2>

          {/* Subtext */}
          <p className="fade-up fade-up-delay-2 mt-10 md:mt-14 text-base md:text-lg text-foreground-300 leading-relaxed max-w-xl mx-auto">
            We design and develop scalable, maintainable systems with
            a relentless focus on usability, stability, and long-term
            technical quality.
          </p>
        </div>
      </div>

      {/* Bottom fade to next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-100 to-transparent pointer-events-none"></div>
    </section>
  );
}